const ActualBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.billable_time'}),
		details: [formatMessage({id: 'utilization.actual_billable_project_time.description'})],
	},
];

const ActualNonBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.non_billable_time'}),
		details: [formatMessage({id: 'utilization.actual_non_billable_project_time.description'})],
	},
];

const ActualInternalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.internal_time'}),
		details: [formatMessage({id: 'utilization.actual_internal_time.description'})],
	},
];

const ActualTotalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.total_time'}),
		details: [formatMessage({id: 'utilization.actual_total_time.description'})],
	},
];

const ActualOverTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.over_time'}),
		details: [formatMessage({id: 'utilization.actual_total_time.description'}), '–', formatMessage({id: 'utilization.available_time'})],
	},
];

const ActualBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.billable_utilization'}),
		details: [formatMessage({id: 'utilization.actual_billable_project_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ActualNonBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.non_billable_utilization'}),
		details: [formatMessage({id: 'utilization.actual_non_billable_project_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ActualInternalUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.internal_utilization'}),
		details: [formatMessage({id: 'utilization.actual_internal_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ActualResourceUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.resource_utilization'}),
		details: [formatMessage({id: 'utilization.actual_total_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const PlannedBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.billable_time'}),
		details: [formatMessage({id: 'utilization.planned_billable_project_time.description'})],
	},
];

const PlannedNonBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.non_billable_time'}),
		details: [formatMessage({id: 'utilization.planned_non_billable_project_time.description'})],
	},
];

const PlannedInternalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.internal_time'}),
		details: [formatMessage({id: 'utilization.planned_internal_time.description'})],
	},
];

const PlannedTotalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.total_time'}),
		details: [formatMessage({id: 'utilization.planned_total_time.description'})],
	},
];

const PlannedOverTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.over_time'}),
		details: [formatMessage({id: 'utilization.planned_total_time.description'}), '–', formatMessage({id: 'utilization.available_time'})],
	},
];

const PlannedBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.billable_utilization'}),
		details: [formatMessage({id: 'utilization.planned_billable_project_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const PlannedNonBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.non_billable_utilization'}),
		details: [formatMessage({id: 'utilization.planned_non_billable_project_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const PlannedInternalUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.internal_utilization'}),
		details: [formatMessage({id: 'utilization.planned_internal_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const PlannedResourceUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.resource_utilization'}),
		details: [formatMessage({id: 'utilization.planned_total_time.description'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ActualVsPlanBillableToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.billable_actual_vs_plan'}),
		details: [formatMessage({id: 'utilization.actual_billable_project_time.description'}), '–', formatMessage({id: 'utilization.planned_billable_project_time.description'})],
	},
];

const ActualVsPlanNonBillableToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.non_billable_actual_vs_plan'}),
		details: [formatMessage({id: 'utilization.actual_non_billable_project_time.description'}), '–', formatMessage({id: 'utilization.planned_non_billable_project_time.description'})],
	},
];

const ActualVsPlanInternalToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.internal_actual_vs_plan'}),
		details: [formatMessage({id: 'utilization.actual_internal_time.description'}), '–', formatMessage({id: 'utilization.planned_internal_time.description'})],
	},
];

const ActualVsPlanTotalToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.total_actual_vs_plan'}),
		details: [formatMessage({id: 'utilization.actual_total_time.description'}), '–', formatMessage({id: 'utilization.planned_total_time.description'})],
	},
];

const RemainingBillableProjectTimeToolTip = (isUsingProjectAllocation, formatMessage) => [
	{
		title: formatMessage({id: 'utilization.billable_time'}),
		details: isUsingProjectAllocation
			? [formatMessage({id: 'utilization.remaining_billable_project_time.project_allocation'})]
			: [formatMessage({id: 'utilization.all_future_billable_estimates'}), '–', formatMessage({id: 'utilization.past_billable_time_registrations'})],
	},
];

const RemainingNonBillableProjectTimeToolTip = (isUsingProjectAllocation, formatMessage) => [
	{
		title: formatMessage({id: 'utilization.non_billable_time'}),
		details: isUsingProjectAllocation
			? [formatMessage({id: 'utilization.remaining_non_billable_project_time.project_allocation'})]
			: [formatMessage({id: 'utilization.all_future_non_billable_estimates'}), '–', formatMessage({id: 'utilization.past_non_billable_time_registrations'})],
	},
];

const RemainingInternalTimeToolTip = (isUsingProjectAllocation, formatMessage) => [
	{
		title: formatMessage({id: 'common.internal_time'}),
		details: isUsingProjectAllocation ? [formatMessage({id: 'utilization.remaining_internal_time.project_allocation'})] : [formatMessage({id: 'utilization.remaining_internal_time.task_allocation'})],
	},
];

const RemainingTotalTimeToolTip = (isUsingProjectAllocation, formatMessage) => [
	{
		title: formatMessage({id: 'utilization.total_time'}),
		details: isUsingProjectAllocation
			? [formatMessage({id: 'utilization.remaining_total_time.project_allocation'})]
			: [formatMessage({id: 'utilization.planned_total_time.description'}), '–', formatMessage({id: 'utilization.actual_total_time.description'})],
	},
];

const RemainingOverTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.over_time'}),
		details: [formatMessage({id: 'utilization.all_remaining_time'}), '–', formatMessage({id: 'utilization.available_time'})],
	},
];

const RemainingBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.billable_utilization'}),
		details: [formatMessage({id: 'utilization.all_remaining_billable_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const RemainingNonBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.non_billable_utilization'}),
		details: [formatMessage({id: 'utilization.all_remaining_non_billable_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const RemainingInternalUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.internal_utilization'}),
		details: [formatMessage({id: 'utilization.all_remaining_internal_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const RemainingResourceUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.resource_utilization'}),
		details: [formatMessage({id: 'utilization.all_remaining_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ForecastedBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.billable_time'}),
		details: [formatMessage({id: 'utilization.actual_billable_project_time.description'}), '+', formatMessage({id: 'utilization.all_remaining_billable_time'})],
	},
];

const ForecastedNonBillableProjectTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.non_billable_time'}),
		details: [formatMessage({id: 'utilization.actual_non_billable_project_time.description'}), '–', formatMessage({id: 'utilization.all_remaining_non_billable_time'})],
	},
];

const ForecastedInternalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.internal_time'}),
		details: [formatMessage({id: 'utilization.actual_internal_time.description'}), '+', formatMessage({id: 'utilization.all_remaining_internal_time'})],
	},
];

const ForecastedTotalTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.total_time'}),
		details: [formatMessage({id: 'utilization.actual_total_time.description'}), '+', formatMessage({id: 'utilization.all_remaining_time'})],
	},
];

const ForecastedOverTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.over_time'}),
		details: [formatMessage({id: 'utilization.all_forecasted_time'}), '–', formatMessage({id: 'utilization.available_time'})],
	},
];

const ForecastedBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.billable_utilization'}),
		details: [formatMessage({id: 'utilization.forecasted_billable_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ForecastedNonBillableUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.non_billable_utilization'}),
		details: [formatMessage({id: 'utilization.forecasted_non_billable_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ForecastedInternalUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.internal_utilization'}),
		details: [formatMessage({id: 'utilization.forecasted_internal_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const ForecastedResourceUtilizationToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.resource_utilization'}),
		details: [formatMessage({id: 'utilization.all_forecasted_time'}), '/', formatMessage({id: 'utilization.available_time'}), 'x', '100'],
	},
];

const WorkingTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.working_time'}),
		details: [formatMessage({id: 'utilization.working_time.description'}), '-', formatMessage({id: 'utilization.public_holidays.description'})],
	},
];

const TimeOffToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.time_off'}),
		details: [formatMessage({id: 'utilization.time_off.description'})],
	},
];

const AvailableTimeToolTip = formatMessage => [
	{
		title: formatMessage({id: 'utilization.available_time'}),
		details: [formatMessage({id: 'utilization.working_time'}), '–', formatMessage({id: 'common.time_off'})],
	},
];

const PerformanceToolTip = formatMessage => [
	{
		title: formatMessage({id: 'common.performance'}),
		details: [formatMessage({id: 'utilization.planned_time_on_done_tasks'}), '/', formatMessage({id: 'utilization.actual_time_on_done_tasks'}), 'x', '100'],
	},
];

export const UtilizationReportToolTips = {
	ActualBillableProjectTimeToolTip,
	ActualNonBillableProjectTimeToolTip,
	ActualInternalTimeToolTip,
	ActualTotalTimeToolTip,
	ActualOverTimeToolTip,
	ActualBillableUtilizationToolTip,
	ActualNonBillableUtilizationToolTip,
	ActualInternalUtilizationToolTip,
	ActualResourceUtilizationToolTip,
	PlannedBillableProjectTimeToolTip,
	PlannedNonBillableProjectTimeToolTip,
	PlannedInternalTimeToolTip,
	PlannedTotalTimeToolTip,
	PlannedOverTimeToolTip,
	PlannedBillableUtilizationToolTip,
	PlannedNonBillableUtilizationToolTip,
	PlannedInternalUtilizationToolTip,
	PlannedResourceUtilizationToolTip,
	ActualVsPlanBillableToolTip,
	ActualVsPlanNonBillableToolTip,
	ActualVsPlanInternalToolTip,
	ActualVsPlanTotalToolTip,
	RemainingBillableProjectTimeToolTip,
	RemainingNonBillableProjectTimeToolTip,
	RemainingInternalTimeToolTip,
	RemainingTotalTimeToolTip,
	RemainingOverTimeToolTip,
	RemainingBillableUtilizationToolTip,
	RemainingNonBillableUtilizationToolTip,
	RemainingInternalUtilizationToolTip,
	RemainingResourceUtilizationToolTip,
	ForecastedBillableProjectTimeToolTip,
	ForecastedNonBillableProjectTimeToolTip,
	ForecastedInternalTimeToolTip,
	ForecastedTotalTimeToolTip,
	ForecastedOverTimeToolTip,
	ForecastedBillableUtilizationToolTip,
	ForecastedNonBillableUtilizationToolTip,
	ForecastedInternalUtilizationToolTip,
	ForecastedResourceUtilizationToolTip,
	WorkingTimeToolTip,
	TimeOffToolTip,
	AvailableTimeToolTip,
	PerformanceToolTip,
};
